/**
 * Temporary browser helper for testing RBAC roles.
 * Remove before deploying to production.
 *
 * Usage in browser console:
 *   window.__setTestRole("platform_admin")
 *   window.__setTestRole("tenant_admin")
 *   window.__setTestRole("support_agent")
 *   window.__setTestRole("viewer")
 */
import { getDataFromLocalStorage, setDataOnLocalStorage } from "./localStorage";

window.__setTestRole = (role, tenantId = "1") => {
  const user = getDataFromLocalStorage("userInfo");
  if (!user) {
    console.error("No userInfo in localStorage. Log in first.");
    return;
  }
  user.role = role;
  user.tenantId = tenantId;
  setDataOnLocalStorage("userInfo", user);
  console.log(`Role set to "${role}". Reloading...`);
  setTimeout(() => window.location.reload(), 500);
};

window.__getTestRole = () => {
  const user = getDataFromLocalStorage("userInfo");
  console.log("Current role:", user?.role);
  return user?.role;
};
